import { Popover, Checkbox, Button } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import trans from "../../../utils";
import { useReportColumnsContext } from "./reportColumns";

export default function ReportColumnSettings() {
	const ctx = useReportColumnsContext();

	if (!ctx?.defs?.length) return null;

	const { defs, visibleKeys, mandatoryKeys, setVisibleKeys, reset } = ctx;

	const toggle = (key) => {
		if (mandatoryKeys.includes(key)) return;
		const next = visibleKeys.includes(key)
			? visibleKeys.filter((item) => item !== key)
			: [...visibleKeys, key];
		setVisibleKeys(next);
	};

	const content = (
		<div className="d-flex flex-column gap-2" style={{ minWidth: 220 }}>
			{defs.map((col) => {
				const mandatory = mandatoryKeys.includes(col.key);
				return (
					<Checkbox
						key={col.key}
						checked={mandatory || visibleKeys.includes(col.key)}
						disabled={mandatory}
						onChange={() => toggle(col.key)}
					>
						{col.title}
					</Checkbox>
				);
			})}
			<Button type="link" onClick={reset} style={{ paddingInline: 0, alignSelf: "flex-start" }}>
				{trans("Reset to Default")}
			</Button>
		</div>
	);

	return (
		<Popover
			title={trans("Columns")}
			content={content}
			trigger="click"
			placement="bottomRight"
		>
			<Button icon={<SettingOutlined />}>{trans("Columns")}</Button>
		</Popover>
	);
}
